"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_dom_1 = require("react-dom");
const App_1 = require("./App");
react_dom_1.render(React.createElement(App_1.App, null), document.getElementById('demo'));



//////////////////
// WEBPACK FOOTER
// ./src/demo/index.tsx
// module id = 134
// module chunks = 0